import * as React from "react";
import { IE2ETestableComponent } from "../../core/e2e/IE2ETestableComponent";
import { Input } from "./components/Input";
import { Label } from "./components/Label";
import { Wrapper } from "./components/Wrapper";

export interface ISettingToggle extends IE2ETestableComponent {
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  onToggle?: React.MouseEventHandler<HTMLLabelElement>;
  theme?: object;
}

// tslint:disable-next-line
const randomID = () => "c" + (0 | (Math.random() * 9e6)).toString(36);

export const SettingToggle = ({
  onToggle,
  checked,
  ...props
}: ISettingToggle) => {
  const id = randomID();
  return (
    <Wrapper className={props.className}>
      <Input
        id={id}
        defaultChecked={checked}
        data-checked={checked}
        disabled={props.disabled}
        type="checkbox"
      />
      <Label htmlFor={id} data-e2e-id={props.dataE2EId} onClick={onToggle} />
    </Wrapper>
  );
};
